module.exports = __webpack_public_path__ + "static/img/df882c49bd2bdb901627a0c27398197a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/产品与服务-改(1)_49.jpg
// module id = b118
// module chunks = 1